import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { scrollToForm } from "@/App";

const BLOCKS = [
  { label: "Victorian Energy Upgrades discount", tone: "bg-glight/25 text-navy" },
  {
    label: "Solar Victoria rebate (up to $1,000, or $1,400 for locally made)",
    tone: "bg-glight/45 text-navy",
  },
  { label: "Federal STC discount", tone: "bg-gdark text-white" },
];

const RebateStack = () => {
  return (
    <section
      data-testid="rebate-stack-section"
      className="bg-cream py-16 md:py-24"
    >
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gdark mb-4 flex items-center justify-center gap-2">
            <span className="inline-block w-8 h-px bg-gdark" />
            How the rebates stack
            <span className="inline-block w-8 h-px bg-gdark" />
          </p>
          <h2 className="font-serif font-bold text-navy tracking-tight text-4xl md:text-5xl leading-tight">
            Three discounts. One lower price.
          </h2>
        </motion.div>

        <div className="mt-12 flex flex-col items-center">
          {BLOCKS.map((b, i) => (
            <motion.div
              key={b.label}
              initial={{ opacity: 0, y: -32, scale: 0.96 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.18, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`rebate-block-${i}`}
              className={`w-full max-w-xl rounded-[16px] px-6 py-5 font-semibold text-base md:text-lg shadow-md ${b.tone} ${i > 0 ? "-mt-2" : ""}`}
              style={{ zIndex: i + 1, position: "relative" }}
            >
              {b.label}
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.4, delay: 0.62 }}
            className="my-4"
            aria-hidden="true"
          >
            <ArrowDown className="w-7 h-7 text-gdark" />
          </motion.div>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.72 }}
            onClick={scrollToForm}
            data-testid="rebate-stack-cta"
            className="rounded-[16px] bg-navy px-10 py-6 font-serif font-black text-white text-3xl md:text-4xl tracking-tight shadow-xl hover:-translate-y-0.5 transition-transform duration-200"
          >
            Your fixed price, <span className="text-glight">with rebates applied</span>
          </motion.button>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.85 }}
          data-testid="rebate-stack-caption"
          className="mt-6 text-sm text-navy-muted max-w-xl mx-auto"
        >
          Solar Victoria rebate and VEU discount can be combined: up to $2,030
          off for locally made systems (Solar Victoria). Eligibility applies.
        </motion.p>
      </div>
    </section>
  );
};

export default RebateStack;
